import type { ButtonHTMLAttributes, ReactNode } from 'react';

import { cn } from '../lib/cn';

type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger';
type ButtonSize = 'sm' | 'md' | 'lg';

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonVariant;
  size?: ButtonSize;
  children: ReactNode;
};

const variantClasses: Record<ButtonVariant, string> = {
  primary:
    'border-2 border-brut-border bg-brut-accent text-white shadow-brut hover:translate-x-0.5 hover:translate-y-0.5 hover:bg-brut-accent-hover hover:shadow-brut-sm active:translate-x-1 active:translate-y-1 active:shadow-none',
  secondary:
    'border-2 border-brut-border bg-brut-surface text-brut-fg shadow-brut hover:translate-x-0.5 hover:translate-y-0.5 hover:bg-brut-fg hover:text-brut-surface hover:shadow-brut-sm active:translate-x-1 active:translate-y-1 active:shadow-none',
  ghost:
    'border-2 border-transparent bg-transparent text-brut-fg hover:border-brut-border hover:bg-brut-surface',
  danger:
    'border-2 border-brut-border bg-brut-danger text-white shadow-brut hover:translate-x-0.5 hover:translate-y-0.5 hover:shadow-brut-sm active:translate-x-1 active:translate-y-1 active:shadow-none',
};

const sizeClasses: Record<ButtonSize, string> = {
  sm: 'px-3 py-1.5 text-xs',
  md: 'px-4 py-2 text-sm',
  lg: 'px-5 py-3 text-sm',
};

export function Button({
  variant = 'primary',
  size = 'md',
  className,
  disabled,
  children,
  ...props
}: ButtonProps) {
  return (
    <button
      type="button"
      disabled={disabled}
      className={cn(
        'inline-flex items-center justify-center font-bold uppercase tracking-wide no-underline',
        'disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:translate-x-0 disabled:hover:translate-y-0 disabled:hover:shadow-brut',
        variantClasses[variant],
        sizeClasses[size],
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
}
